import SpriteSymbol from "svg-baker-runtime/browser-symbol";
import sprite from "svg-sprite-loader/runtime/browser-sprite.build";
var symbol = new SpriteSymbol({
  "id": "search1",
  "use": "search1-usage",
  "viewBox": "0 0 16 16",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 16 16\" id=\"search1\"><title>search1</title><path d=\"M14.844 14.031l-3.219-3.203Q13 9.156 13 7q0-2.484-1.758-4.242T7 1 2.758 2.758 1 7t1.758 4.242T7 13q2.156 0 3.828-1.375l3.219 3.219q.156.156.391.156t.406-.156q.156-.172.156-.406t-.156-.406zM8.891 11.5Q8 11.875 7 11.875T5.109 11.5q-.875-.375-1.555-1.055T2.515 8.89q-.391-.891-.391-1.891t.391-1.891q.359-.875 1.039-1.555t1.555-1.055Q6 2.123 7 2.123t1.891.375q.875.375 1.555 1.055t1.055 1.555q.375.891.375 1.891t-.375 1.891q-.375.875-1.055 1.555T8.891 11.5z\" /></symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./~/wc-lib/icons/search1.svg
// module id = 480
// module chunks = 0